import { insertArrayItem } from './helpers';

const deleteItems = <T extends Record<string, any> | string>(data: T[], ids: string[], property: string = '_id') =>
  data.filter((item: T) =>
    !item || typeof item === 'object'
      ? !item[property as keyof T] ||
        typeof item[property as keyof T] !== 'string' ||
        !ids.includes(String(item[property as keyof T]))
      : !item || !ids.includes(item)
  );

const addItems = <T>(data: T[], items: T[], start = true) => (start ? [...items, ...data] : [...data, ...items]);

const editItem = <T extends Record<string, any>>(data: T[], index: number, newItem: T) =>
  insertArrayItem<T>(data, index, newItem);

const editItems = <T extends Record<string, any>>(data: T[], ids: string[], changes: Partial<T>, property = '_id') =>
  data.map((prevTableItem) =>
    prevTableItem[property] && ids.includes(prevTableItem[property]) ? { ...prevTableItem, ...changes } : prevTableItem
  );

const deleteItem = <T extends Record<string, any>>(data: T[], id: string, property = '_id') =>
  data.filter((item) => !item[property] || item[property] !== id);

export { addItems, deleteItems, deleteItem, editItem, editItems };
